export default __webpack_public_path__ + "static/media/logo-uniti.1fce96f5.jpg";